import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { UserState } from '../_shared/state/user.state';
import { LoanComputationService } from '../my-home-page/service/loan-computation.service';
import { MyHomeService } from '../my-home-page/service/my-home.service';
import { MyHomeState } from '../my-home-page/state/my-home.state';
import { ConfirmDialogComponent } from '../shared/modules/alerts/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-saved-equity-analysis',
  templateUrl: './saved-equity-analysis.component.html',
  styleUrls: ['./saved-equity-analysis.component.scss']
})
export class SavedEquityAnalysisComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  totalRecords = 0;
  pageIndex = 0;
  pageSize = 5;
  savedEquityList = [];
  loader = true;
  constructor(private myHomeService: MyHomeService, private activatedRoute: ActivatedRoute, private router: Router, public myHomeState: MyHomeState, private loanService: LoanComputationService, private dialog: MatDialog, private userState: UserState,) { }

  ngOnInit(): void {
    this.loadSavedEquityAnalysis();
  }

  loadSavedEquityAnalysis() {
    this.loader = true;
    let params = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    }
    this.myHomeService.getSavedEquityAnalysis(params).subscribe((res) => {
      if (res && res.data && res.data.paginatedResults) {
        this.savedEquityList = res.data.paginatedResults
        this.totalRecords = res?.data.totalRecords
        this.loader = false;

      } else {
        this.savedEquityList = [];
        this.totalRecords = 0;
        this.loader = false;
      }

    });
  }

  analyzeEquity() {
    setTimeout(() => {
      this.userState.isPropertySearchSheetOpen = true;
    }, 300);
    this.userState.propertySearchSheetContent = {
      heading: 'Equity Analysis',
      content: 'Search for any property to run equity analysis',
      isEquityAnalysis: true
    }
  }

  deleteEquityById(id) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '385px',
      disableClose: true,
      hasBackdrop: true,
      data: {
        type: 'deleteEquityAnalaysis',
        message: 'The selected equity will be deleted',
        title: 'Do you want to delete?',
        proceedAction: (status, callBack) => {
          if (status) {
            this.myHomeService.deleteEquityAnalysisById({ equityId: id }).subscribe((res) => {
              if (res) {
                this.loadSavedEquityAnalysis();
                dialogRef.close();
              }
            })
          } else {
            dialogRef.close();
          }
        },
        proceedCancelAction: () => {
          dialogRef.close();
        },
      },
    });

  }


  viewEquity(data, action) {
    const formattedMorgageList = this.setInitialProjection(data);
    this.myHomeState.mortgageListValue = formattedMorgageList?.mortgageList || [];
    this.router.navigate(['equity-analysis'], {
      queryParams: {
        'property-id': data?.PMXPropertyId,
        'equity-id': data?._id,
        'action': action
      },

    });
    this.myHomeState.activeHomePropertyValue = {};
    this.myHomeState.mortgageListValue = [];
    this.myHomeState.customEquityData = null;
    this.myHomeState.customMonthlyData = null;
    this.myHomeState.customMonthlyDataOnLoad = null;
    this.myHomeState.savedEquityData = null;
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadSavedEquityAnalysis();
  }
  setInitialProjection(data) {
    if (data.mortgageHistory && data.mortgageHistory.length) {
      const mortgageList = data.mortgageHistory.map((mortgage) => {
        let loanComputation = this.loanService.computeTotalLoan(
          mortgage.principal,
          mortgage.interest / 100,
          mortgage.term,
          new Date(mortgage.startDate)
        );
        mortgage = { ...mortgage, ...loanComputation };
        mortgage.activeRefinance = this.loanService.computeBalanceLoan(
          loanComputation.principalBalance,
          mortgage.interest / 100,
          15 * 12
        );
        return mortgage;
      });
      data.mortgageList = mortgageList;
    }
    return data;

  }
}
